import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://thelifespanproject.com";

const SITE = "The Lifespan Project";
const DEFAULT_DESC =
  "The Lifespan Project, a multidisciplinary human-longevity research initiative advancing the science of longer, healthier human life across physics, quantum mechanics, AI, biology, and cognitive science.";

const ROUTES = {
  "/": {
    title: `${SITE}: Advancing Human Longevity`,
    description: DEFAULT_DESC,
  },
  "/subscribe": {
    title: `Subscribe: Founding Membership | ${SITE}`,
    description:
      "Become a Founding Member of The Lifespan Project. Prime membership at ₹1,900 per month or Pro lifetime membership at ₹1,90,000, with Digital Founding Membership access to the growing Lifespan ecosystem.",
    image: "https://thelifespanproject.com/og-subscribe.png",
  },
  "/back-us": {
    title: `Back Us: Invest in Human Longevity Research | ${SITE}`,
    description:
      "Investor relations for The Lifespan Project, a multidisciplinary human-longevity research initiative. Request the investor brief and research roadmap.",
    image: "https://thelifespanproject.com/og-backus.png",
  },
  "/apply": {
    title: `Apply: Join Our Longevity Research Team | ${SITE}`,
    description:
      "Collaborate with The Lifespan Project. Open to doctorates, MBBS, MD, PhD and double-major post-graduates with 5+ years of professional experience, in India or abroad.",
    image: "https://thelifespanproject.com/og-apply.png",
  },
  "/payment/success": {
    title: `Payment Confirmed: ${SITE}`,
    description: DEFAULT_DESC,
    noindex: true,
  },
  "/payment/cancel": {
    title: `Payment Cancelled: ${SITE}`,
    description: DEFAULT_DESC,
    noindex: true,
  },
  "/terms": {
    title: `Terms of Membership: ${SITE}`,
    description:
      "Terms of Membership for The Lifespan Project: membership tiers, payments, research status and your rights under Indian and international law.",
  },
  "/privacy": {
    title: `Privacy Policy & Data Usage: ${SITE}`,
    description:
      "How The Lifespan Project collects, uses and protects your data: DPDP Act (India), GDPR (Europe), UK GDPR, CCPA and PIPEDA compliant.",
  },
  "/refund": {
    title: `Refund Policy: ${SITE}`,
    description:
      "Refund Policy of The Lifespan Project: memberships are instantly delivered digital grants; all payments are final, genuine errors always corrected.",
  },
  "/faq": {
    title: `FAQs: ${SITE}`,
    description:
      "Frequently asked questions about The Lifespan Project: a for-profit longevity R&D organization, its work in progress, memberships and payments.",
  },
  "/assessment": {
    title: "Lifespan Markers Check | The Lifespan Project",
    description:
      "Free Level 0 Assessment: answer 30 quick questions and see your Lifespan Markers, a body and mind baseline compared with the world average. 4-5 minutes, no login, private.",
    image: "https://thelifespanproject.com/og-assessment.png",
  },
  "/assessment/level-1": {
    title: "Mental Marker Scan | The Lifespan Project",
    description:
      "Free Level 1 Assessment: an on-device camera and voice scan plus twelve quick check-ins, giving you a Mental Marker reading in minutes. Private by design: video and audio never leave your device.",
    image: "https://thelifespanproject.com/og-assessment.png",
  },
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isResult = pathname.startsWith("/assessment/result") || pathname.startsWith("/assessment/level-1/results");
    const route = isResult
      ? { title: "Your Lifespan Markers | The Lifespan Project", description: "", noindex: true }
      : ROUTES[pathname] || ROUTES["/"];
    document.title = route.title;
    setMeta('meta[name="description"]', "content", route.description);
    setMeta('meta[property="og:title"]', "content", route.title);
    setMeta('meta[property="og:description"]', "content", route.description);
    setMeta('meta[name="twitter:title"]', "content", route.title);
    setMeta('meta[name="twitter:description"]', "content", route.description);
    const ogImage = isResult ? `${BASE}/og-image.png` : (route.image || `${BASE}/og-image.png`);
    setMeta('meta[property="og:image"]', "content", ogImage);
    setMeta('meta[property="og:image:secure_url"]', "content", ogImage);
    setMeta('meta[name="twitter:image"]', "content", ogImage);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (route.noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }

    const pageUrl = `${BASE}${pathname === "/" ? "/" : pathname}`;
    setMeta('meta[property="og:url"]', "content", pageUrl);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", pageUrl);
  }, [pathname]);

  return null;
};

export default SEO;
